import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _popupVariants;

import { DefaultPopup, ErrorPopup, InfoPopup, NotReceiveCode, SuccessPopup } from '@popups';
import { Popups } from '@enums';
export var popupVariants = (_popupVariants = {}, _defineProperty(_popupVariants, Popups.Success, SuccessPopup), _defineProperty(_popupVariants, Popups.Info, InfoPopup), _defineProperty(_popupVariants, Popups.Error, ErrorPopup), _defineProperty(_popupVariants, Popups.Default, DefaultPopup), _defineProperty(_popupVariants, Popups.NotReceiveCode, NotReceiveCode), _popupVariants);